import { render, staticRenderFns } from "./ValeSidebarAddNewCustomer.vue?vue&type=template&id=1dbe8e44&"
import script from "./ValeSidebarAddNewCustomer.vue?vue&type=script&lang=js&"
export * from "./ValeSidebarAddNewCustomer.vue?vue&type=script&lang=js&"
import style0 from "./ValeSidebarAddNewCustomer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports